import { BACKERS } from "@/data/site";

export const BackerStrip = ({ className = "" }) => (
  <div className={`flex flex-wrap items-center justify-center gap-4 ${className}`} data-testid="backer-strip">
    {BACKERS.map((b) => (
      <div
        key={b.name}
        title={b.name}
        className="group flex h-16 w-36 items-center justify-center border border-white/10 bg-bone/95 px-5 transition-colors duration-300 hover:bg-bone md:w-40"
      >
        <img
          src={b.file}
          alt={b.name}
          className="max-h-9 w-auto object-contain opacity-70 grayscale transition-all duration-500 group-hover:opacity-100 group-hover:grayscale-0"
          loading="lazy"
        />
      </div>
    ))}
  </div>
);
